import { writeSettingsFields } from './settings-fields';

/** `PATCH /client/settings/fields`: `settings.recipient_name`. */
export const editRecipientName = async (recipient_name: object): Promise<any> =>
  writeSettingsFields({ recipient_name });
